import { useState, useEffect, useRef, Fragment, memo, useContext } from "react";
import style from "./../index.module.scss";
import styleUi from "./ViewPhoto.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import * as YStyled from "../../Styleds";
import FriendInfo from "../../comm/global/components/FriendInfo";
import EXIF from "exif-js";
import { getCountyAndTown } from "../../comm/comm";
import { GameContext } from "../../GameContext";
const ViewPhoto = ({ setModalType, arg, addModalType }) => {
    const { tempEvent } = useContext(GameContext);
    const [inProp, setInProp] = useState(false);
    const [selectInd, set_selectInd] = useState(0);
    const [data, set_data] = useState([]);
    const [loc, set_loc] = useState("");
    useEffect(() => {
        console.log("tempEvent", tempEvent)
        console.log("polaroid", arg.polaroid)
        console.log("overlayAlbumArr", arg.overlayAlbumArr)
        const index = arg.overlayAlbumArr.findIndex(v => v.event_polaroids_id === arg.polaroid.event_polaroids_id);
        set_selectInd(index);
        set_data(arg.overlayAlbumArr)
        setInProp(true);
    }, [])
    useEffect(() => {
        if (data[selectInd]) {
            const obj = data[selectInd];
            getCountyAndTown(obj.event_polaroids_lat, obj.event_polaroids_lng).then(res => {
                set_loc(res);
            })
        }
    }, [data, selectInd])

    const shareImage = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: tempEvent.events_name,
                    text: '',
                    url: data[selectInd].event_polaroids_url,
                });
            } catch (error) {
                console.error('分享失败', error);
            }
        } else {
            downloadImage();
        }
    };
    const downloadImage = () => {
        const link = document.createElement('a');
        link.href = data[selectInd].event_polaroids_url;
        link.target = "_blank";
        link.download = "photo"; // 设置下载文件的默认名称
        document.body.appendChild(link);
        link.click();
    };

    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "ViewPhoto"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.headerBar}>
                                    <IconButton onClick={e => {
                                        setInProp(false)
                                    }}>
                                        <ArrowBackIosNewIcon />
                                    </IconButton>
                                </div>
                                <div className={styleUi.view}>

                                    <div className={styleUi.ctrl}>
                                        <img src="./assets/ui/download_c.png" onClick={e => {
                                            downloadImage()
                                        }} />
                                        <img src="./assets/ui/share_c.png" onClick={e => {
                                            shareImage()
                                        }} />
                                    </div>
                                    <div className={styleUi.list}>
                                        <div className={styleUi.photo} style={{opacity:selectInd > 0?1:0}} >
                                        </div>
                                        <img src="./assets/ui/arrowLeft.png" style={{opacity:selectInd > 0?1:0}} onClick={e => {
                                            set_selectInd(prev => {
                                                return prev > 0 ? prev - 1 : 0;
                                            })
                                        }} />
                                        <div className={styleUi.photo}>
                                            <img src={data[selectInd]?.event_polaroids_url} />
                                            <YStyled.Row>
                                                <YStyled.Label style={{ padding: "4px 10px", borderRadius: "18px", background: "#F8F8F8" }}>
                                                    <YStyled.Span size={11} >{loc}</YStyled.Span>
                                                </YStyled.Label>
                                                <YStyled.Label style={{ padding: "4px 10px", borderRadius: "18px", background: "#F8F8F8" }}>
                                                    <YStyled.Span size={11} >沒有提供日期</YStyled.Span>
                                                </YStyled.Label>
                                            </YStyled.Row>
                                            <YStyled.Label style={{ padding: "4px 10px", borderRadius: "18px", background: "#F8F8F8", width: "100%", justifyContent: "flex-start" }}>
                                                <YStyled.Span size={11} >{data[selectInd]?.event_polaroids_message}</YStyled.Span>
                                            </YStyled.Label>
                                            <YStyled.Label style={{ padding: "4px 10px", borderRadius: "18px", background: "#F8F8F8", alignSelf: "flex-end" }}>
                                                <YStyled.Span size={11} >{data[selectInd]?.event_polaroids_created_by_user.user_name}</YStyled.Span>
                                            </YStyled.Label>
                                        </div>

                                        <img src="./assets/ui/arrowRight.png" style={{opacity:selectInd >= arg.overlayAlbumArr.length - 1?0:1}} onClick={e => {
                                            set_selectInd(prev => prev < data.length - 1 ? prev + 1 : prev);
                                        }} />
                                        <div className={styleUi.photo} style={{opacity:selectInd >= arg.overlayAlbumArr.length - 1?0:1}}>
                                        </div>

                                </div>
                                {data.length > 1 &&
                                    <div className={styleUi.dotList}>
                                        {data.map((v, k) => {
                                            return <div key={k} className={`${styleUi.dot} ${selectInd === k ? styleUi.selected : ""}`}></div>
                                        })}
                                    </div>
                                }
                                {/* <YStyled.BTN2 className={styleUi.btn} style={{ width: "100%", background: "#000000", color: "#fff", marginTop: "6rem",width:"90%" }} onClick={e => {
                                    }}>
                                        <YStyled.Span size={17} >下載</YStyled.Span>
                                    </YStyled.BTN2> */}
                            </div>
                        </div>
                </div>
            </CSSTransition>
        </div>
            </CSSTransition >
        </div >
    );
}

export default memo(ViewPhoto);